import { PlotKey } from './packet.worker'

// Color picker for variable telemetry plot keys.
// Using the plot key string as input, this deterministically picks a color
// using similar color appearance (saturation and lightness) as the legacy
// telemetry.

// Mean saturation and lightness of realtime data packet display colors
const SATURATION = 0.78
const LIGHTNESS = 0.62

export const plotKeyToRgbStr = (plotKey: PlotKey): string => {
  const h = plotKeyToHue(plotKey)
  return hslToHex(h, SATURATION * 100, LIGHTNESS * 100)
}

// Pick a hue degree between 30 and 330
const plotKeyToHue = (plotKey: PlotKey): number => {
  return Math.round(mod(sdbm(plotKey), 300) + 30)
}

// Like % but ensure no negative numbers
const mod = (n: number, m: number): number => (m + (n % m)) % m

// Adapted from top soln (@Juraj) of https://stackoverflow.com/questions/36721830/convert-hsl-to-rgb-and-hex
// s (saturation) and l (lightness) are percentages.
const hslToHex = (h: number, s: number, l: number): string => {
  l /= 100
  const a = (s * Math.min(l, 1 - l)) / 100
  const f = (n: number) => {
    const k = (n + h / 30) % 12
    const color = l - a * Math.max(Math.min(k - 3, 9 - k, 1), -1)
    return Math.round(255 * color)
      .toString(16)
      .padStart(2, '0') // convert to Hex and prefix "0" if needed
  }
  return `#${f(0)}${f(8)}${f(4)}`
}

// SDBM non-cryptographic hash, invented by Daniel Bernstein.
// This implementation returns an integer roughly in the range (-3e10, 3e10).
// JS impl. from https://labex.io/tutorials/hash-string-into-number-28373
const sdbm = (str: string): number => {
  let arr = str.split('')
  return arr.reduce(
    (hashCode, currentVal) =>
      (hashCode = currentVal.charCodeAt(0) + (hashCode << 6) + (hashCode << 16) - hashCode),
    0
  )
}
